import React from "react";
import EAIcon from "./EAIcon";
import { ERROR, INFO, SUCCESS, WARNING } from 'services/common/Constants';

/**
 * EAIcon component with close icon
 * @param severity ERROR | INFO | SUCCESS
 */
const EAAlertCloseIcon = ({ severity }) => {
  switch (severity) {
    case ERROR: return <EAIcon icon={"close_red"} />;
    case INFO: return <EAIcon icon={"arrow/arrow-to-right_large_green"} />;
    case SUCCESS: return <EAIcon icon={"close_green"} />;
    case WARNING: return <EAIcon icon={"close_yellow"} />;
    default: return;
  }
}

export default EAAlertCloseIcon;
